module.exports = __webpack_public_path__ + "cc2b509a0fb619863d615cb29fcaea3f.jpg";